export const SETUP_AUDIO_PENDING = 'SETUP_AUDIO_PENDING'
export const SETUP_AUDIO_SUCCESS = 'SETUP_AUDIO_SUCCESS'
export const SETUP_AUDIO_ERROR = 'SETUP_AUDIO_ERROR'

export const PLAY_SOUND = 'PLAY_SOUND'
export const STOP_SOUND = 'STOP_SOUND'
export const STOP_ALL_SOUND = 'STOP_ALL_SOUND'



// WEBPACK FOOTER //
// ./src/containers/Engine/containers/AudioSource/actionTypes.js